import Vue from 'vue'

export const SET_IMAGEFLAG = 'SET_IMAGEFLAG';

export default {
  state: {flag: 0},
  mutations: {
    [SET_IMAGEFLAG](state, flag) {
      Vue.set(state, 'flag', flag)
    },

  },
  actions: {
    [SET_IMAGEFLAG]({commit}, flag) {
      commit(SET_IMAGEFLAG, flag)
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/imageFlag.js